import _styled from "styled-components";
import type { SanityReferenceSummary } from "@ouster/shared";
import { Tag } from "~/features/ui/tag";
type Props = {
  industries?: SanityReferenceSummary[];
  tagVariant?: React.ComponentProps<typeof Tag>["variant"];
};
export function CaseStudyTags({
  industries,
  tagVariant
}: Props) {
  if (!industries?.length) {
    return null;
  }
  return <_StyledUl>
      {industries.map((industry, index) => <Tag as="li" key={industry._id ?? index} variant={tagVariant}>
          {industry.title}
        </Tag>)}
    </_StyledUl>;
}
var _StyledUl = /*#__PURE__*/_styled("ul").withConfig({
  displayName: "case-study-tags___StyledUl",
  componentId: "sc-19ymsgs-0"
})({
  "position": "relative",
  "zIndex": "10",
  "display": "flex",
  "gap": "0.4rem"
});